import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {PlanetParameters, ViewerParameters} from '../../../../lib/bean/ViewerParameters';

@Component({
  selector: 'app-viewer-parameters',
  templateUrl: './viewer-parameters.component.html',
  styleUrls: ['./viewer-parameters.component.scss']
})
export class ViewerParametersComponent implements OnInit {

  @Output()
  parameterChange: EventEmitter<ViewerParameters> = new EventEmitter<ViewerParameters>();

  parameters: ViewerParameters;

  constructor() { }

  ngOnInit(): void {
    this.parameters = new ViewerParameters();
    this.parameters.earth = new PlanetParameters();
    this.parameters.mars = new PlanetParameters();

    this.parameters.earth.majorSemiAxis = 1.0;
    this.parameters.earth.excentricity = 0.0167;
    this.parameters.earth.revolutionPeriod = 365.25;
    this.parameters.earth.initialAnomaly = -0.043159;
    this.parameters.earth.initialPhase = 1.79677;

    this.parameters.mars.majorSemiAxis = 1.52371;
    this.parameters.mars.excentricity = 0.0934;
    this.parameters.mars.revolutionPeriod = 686.885;
    this.parameters.mars.initialAnomaly = 0.338423;
    this.parameters.mars.initialPhase = -0.417895;

    var t = this;
    setTimeout(function() {
      t.onParameterChange();
    }, 500);
  }

  onParameterChange(): void {
    this.parameters.earth.averageMovement = Math.PI * 2 / this.parameters.earth.revolutionPeriod;
    this.parameters.mars.averageMovement = Math.PI * 2 / this.parameters.mars.revolutionPeriod;

    this.parameters.earth.majorSemiAxis = parseFloat(this.parameters.earth.majorSemiAxis);
    this.parameters.earth.excentricity = parseFloat(this.parameters.earth.excentricity);
    this.parameters.earth.revolutionPeriod = parseFloat(this.parameters.earth.revolutionPeriod);
    this.parameters.earth.initialAnomaly = parseFloat(this.parameters.earth.initialAnomaly);
    this.parameters.earth.initialPhase = parseFloat(this.parameters.earth.initialPhase);
    this.parameters.mars.majorSemiAxis = parseFloat(this.parameters.mars.majorSemiAxis);
    this.parameters.mars.excentricity = parseFloat(this.parameters.mars.excentricity);
    this.parameters.mars.revolutionPeriod = parseFloat(this.parameters.mars.revolutionPeriod);
    this.parameters.mars.initialAnomaly = parseFloat(this.parameters.mars.initialAnomaly);
    this.parameters.mars.initialPhase = parseFloat(this.parameters.mars.initialPhase);


    this.parameterChange.emit(this.parameters);
  }

}
